import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  alpha,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CreateClientScreen from "../../../../../screens/ClientsScreen/CreateClientScreen";

const CreateDirectVisitModal = ({ show, handleClose, VisitId, ClientId }) => {
  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0px 16px 32px -8px rgba(16, 24, 40, 0.2)",
          maxHeight: "90vh",
          width: "94%",
          maxWidth: "1200px",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: 1.5,
          pb: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E2E8F0",
          bgcolor: "#F8FAFC",
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              bgcolor: alpha("#2469F0", 0.08),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h6" sx={{ color: "#2469F0", fontWeight: 700, fontSize: "1.1rem" }}>
              +
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ color: "#1A1A2E", lineHeight: 1.2, fontSize: "1rem" }}
            >
              Create Direct Visit
            </Typography>
            <Typography variant="caption" sx={{ color: "#6B7280", fontSize: "0.65rem" }}>
              Fill in the details to create a new visit
            </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            color: "#9CA3AF",
            p: 0.5,
            "&:hover": {
              bgcolor: "#F3F4F6",
              color: "#4B5563",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          p: 1.5,
          overflow: "auto",
          flex: 1,
          "&::-webkit-scrollbar": {
            width: "4px",
            height: "4px",
          },
          "&::-webkit-scrollbar-track": {
            bgcolor: "#F1F1F1",
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "#C1C1C1",
            borderRadius: "2px",
            "&:hover": {
              bgcolor: "#A8A8A8",
            },
            "&:active": {
              bgcolor: "#94A3B8",
            },
          },
          scrollbarWidth: "thin",
          scrollbarColor: "#C1C1C1 #F1F1F1",
        }}
      >
        <CreateClientScreen
          initialActiveKey="create-visit"
          initialClient={ClientId}
          initialVisit={VisitId}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CreateDirectVisitModal;